import React from "react";
import SavedAccountsContainer from "../../containers/SavedAccounts";
import "../styles.css";
import HexAuthWrapper from "../../components/HexAuthWrapper";

const SavedAccounts = () => {
  return (
    <div className="app-page-container saved-accounts-page">
      <HexAuthWrapper>
        <SavedAccountsContainer />
      </HexAuthWrapper>
    </div>
  );
};

export default SavedAccounts;
